import {OrganisationDrivingLicenseVerificationTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function drivingLicenceVerificationTypeNameFilter(type: OrganisationDrivingLicenseVerificationTypeEnum) {
  switch (type) {
    case OrganisationDrivingLicenseVerificationTypeEnum.Car: return i18n.t(LF.Car) as string;
    case OrganisationDrivingLicenseVerificationTypeEnum.Scooter: return i18n.t(LF.Scooter) as string;
    case OrganisationDrivingLicenseVerificationTypeEnum.CarAndScooter: return i18n.t(LF.CarAndScooter) as string;
  }
}
